import { BaseResponse } from 'api/api.types';
import { ApiInstance } from 'api/api-instance';
import { getFromLocalStorage } from 'global/utils/storage';
import { LAST_REQUEST_ID } from 'config/constant';
import { SIGN_IN_URL, SIGN_UP_URL, USER_INFO_URL } from './auth.constants';
import { SignInRequest, SignInResponse, SingUpRequest, GetUserInfoResponse, SignUpResponse } from './auth.types';

export class AuthApi extends ApiInstance {
  public signIn(request: SignInRequest): Promise<BaseResponse<SignInResponse>> {
    const u = getFromLocalStorage(LAST_REQUEST_ID);
    return this.execute<SignInResponse>(this.http.post(SIGN_IN_URL, { ...request, u }));
  }

  public async signUp(request: SingUpRequest): Promise<BaseResponse<SignUpResponse>> {
    const u = getFromLocalStorage(LAST_REQUEST_ID);
    return this.execute<SignInResponse>(this.http.post(SIGN_UP_URL, { ...request, u }));
  }

  public async getUserInfo(): Promise<BaseResponse<GetUserInfoResponse>> {
    return this.execute(this.http.get(USER_INFO_URL)).then((response: BaseResponse<any>) => {
      if (!response.hasError()) {
        const { email, groups, profile, rut, tenants, username } = response.data.user.data;

        const user = {
          email,
          firstName: profile?.fatherLastName,
          fullName: profile?.name ? `${profile.name} ${profile?.fatherLastName}` : username,
          groups,
          lastName: profile?.motherLastName,
          profile,
          rut: rut || profile?.rut,
          tenants,
          unique_id: response.data.user.unique_id,
          username,
        };

        return new BaseResponse<GetUserInfoResponse>({ ...response.data, user });
      }

      return response;
    });
  }
}
